<template>
<div class="button-group">
  <div class="button-group-item" v-for="(item, i) in dataToShow" :key="i" @click="openNewTab(item.link)">
    {{item.name}}
  </div>
  <div class="button-group-item" style="cursor:pointer" @click="expand=!expand" v-if="data.length>4">Show {{expand ? 'Less' : 'More'}}</div>
</div>
</template>

<script>
export default {
  name: 'ButtonGroup',

  data () {
    return {
      expand: false
    }
  },

  props: [ 'data' ],

  computed: {
    dataToShow () {
      return this.data.filter((item, i) => { return this.expand || i < 4 })
    }
  },

  methods: {
    openNewTab (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/theme.scss";


.button-group {
  float: left;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.button-group-item {
  margin: 0px 8px;
  cursor: pointer;
  // color: $theme-color;
  color: $link-color;
  font-size: 13px;
  font-weight: 450;
}

.button-group-item:hover {
  color: $theme-color-dark;
}

</style>
